import { getHeaders } from "../../api/api";
import { readWorkflowBuilderResponse, WorkflowBuilderApiError } from "../workflowBuilder/response";
import { claimedRemindersSchema, type WorkflowReminder } from "./models";

const base = `${String(import.meta.env.VITE_BACKEND_URI ?? "").replace(/\/$/, "")}/workflow-builder/reminders`;

async function post(path: string, body: { consumer_id: string; lease_token?: string }, token: string | undefined, signal: AbortSignal): Promise<Response> {
    return fetch(`${base}${path}`, {
        method: "POST",
        cache: "no-store",
        headers: { ...(await getHeaders(token)), "Content-Type": "application/json", "X-Erhol-Workflow-Results": "shift-handover-v1" },
        body: JSON.stringify(body),
        signal
    });
}

export async function claimWorkflowReminders(consumerId: string, token: string | undefined, signal: AbortSignal): Promise<WorkflowReminder[]> {
    const response = await post("/claim", { consumer_id: consumerId }, token, signal);
    return claimedRemindersSchema.parse(await readWorkflowBuilderResponse(response)).reminders;
}

export async function dismissWorkflowReminder(reminder: WorkflowReminder, consumerId: string, token: string | undefined, signal: AbortSignal): Promise<void> {
    const response = await post(
        `/${encodeURIComponent(reminder.id)}/dismiss`,
        {
            consumer_id: consumerId,
            lease_token: reminder.lease_token
        },
        token,
        signal
    );
    if (response.status === 204) return;
    await readWorkflowBuilderResponse(response);
    throw new WorkflowBuilderApiError(`Unexpected reminder response (${response.status}).`, response.status);
}
